export default __webpack_public_path__ + "static/creators-hero-light-eb01a4f665dc5d586b00f1924b253bd6.png";